import { Alert, Form } from "antd";
import BaseModalForm from "components/BaseModalForm";
import message from "components/CustomMessage";
import _ from "lodash";
import { useCallback, useMemo } from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes } from "utils/formUtils";

const ARMIS_DEVICE_TYPES = [
  { label: "Servers", value: "Servers" },
  { label: "Virtual Machines", value: "Virtual Machines" },
  { label: "Engineering Workstations", value: "Engineering Workstations" },
  { label: "Personal Computers", value: "Personal Computers" },
  { label: "Hypervisors", value: "Hypervisors" },
  { label: "Workstations", value: "Workstations" },
];

export default function DeviceTypesForm({
  loginData,
  loginId,
  name,
  configData,
  onUpdateConfigComponent,
}) {
  const [form] = Form.useForm();

  const fields = useMemo(
    () => [
      {
        name: "deviceTypes",
        label: "Device Types",
        type: FieldTypes.MULTI_SELECT,
        placeholder: "Leave blank to select all",
        options: ARMIS_DEVICE_TYPES,
      },
    ],
    [],
  );

  const onSubmit = useCallback(
    async (data) => {
      const deviceTypes = _.isEmpty(data.deviceTypes)
        ? null
        : data.deviceTypes.join(",");
      const finalData = {
        ...loginData,
        deviceTypes,
        ...{ fetchAssets: true },
      };
      await ToolsIntegrationsAPI.updateGenericLoginDetail(
        finalData,
        name,
        loginId,
      ).promise;
      message.success(
        configData?.id
          ? "Configuration updated successfully"
          : "Successfully configured.",
      );
      onUpdateConfigComponent?.();
    },
    [loginData, configData, name, loginId, onUpdateConfigComponent],
  );

  return (
    <BaseModalForm
      fields={fields}
      initialValues={{
        ...configData,
        deviceTypes: configData?.deviceTypes
          ? configData.deviceTypes.split(",")
          : undefined,
      }}
      form={form}
      onOk={onSubmit}
      title="Add Asset Criteria"
    />
  );
}
